import React, { useState } from "react";

const FoodTypeContext = React.createContext();

const FoodTypeProvider = (props) => {
  const [foodType, setFoodType] = useState("");

  function handleFoodType(type) {
    setFoodType(type);
  }

  function resetFoodType() {
    setFoodType("");
  }

  return (
    <FoodTypeContext.Provider
      value={{
        foodType,
        handleFoodType,
        resetFoodType,
      }}
    >
      {props.children}
    </FoodTypeContext.Provider>
  );
};

export { FoodTypeProvider, FoodTypeContext };
